'use client';
import { FC } from "react";
import { BannerCardsData, CardIconData } from "@/utils/strapi/sections/BannerCards";
import ContentFullLayout from "@/layouts/ContentFull.layout";
import Button from "@/components/Button/Button";
import cn from "classnames";
import { useRouter } from "next/navigation";
import ContentLayout from "@/layouts/Content.layout";
import { RichTextRenderer } from "@/components/RichTextRenderer/RichTextRenderer";


const BannerCardsSection: FC<BannerCardsData> = (props: BannerCardsData) => {

  const { deskImage, tabImg, mobImage, cardIconItems, button, title, description } = props;

  const router = useRouter();

  const cardIcon = (cardIconItem?: CardIconData, i?: number) => (
    <div key={i} className="flex gap-2 items-center px-2.5  py-3 min-h-20	mobile:min-h-16  tablet:max-w-78 shadow-lg rounded-lg bg-white " >
      <span className="material-symbols-outlined select-none !text-6xl" style={{ color: `${cardIconItem?.iconColor}` }} >
        {cardIconItem?.IconName}
      </span>
      <div className="grow mobile:text-wrap mobile:leading-3" >
        <RichTextRenderer content={cardIconItem?.RichText} />
      </div>
    </div>)

  const bgStyles = {
    "--img-desk": `url(${deskImage?.url})`,
    "--img-tablet": `url(${tabImg?.url})`,
    "--img-mobile": `url(${mobImage?.url})`,
  }

  return (
    <ContentFullLayout classNames="relative h-auto" >
      <div
        //@ts-ignore
        style={bgStyles}
        className="py-12 bg-origin-border md:bg-center bg-no-repeat bg-cover mobile:bg-[image:var(--img-mobile)] tablet:bg-[image:var(--img-tablet)] bg-[image:var(--img-desk)]"
      >  <ContentLayout classNames="w-full">
          <section id="banner-card-image" className="col-span-12 tablet:col-span-8 mobile:col-span-4 ">
            <div className="w-full h-full flex justify-center items-center mx-auto mobile:px-4 tablet:px-20 desktop:px-45 ">
              <div id="container-cards-button" className="flex flex-col gap-12 items-center justify-center mx-auto">
                <div className="flex flex-col gap-1 items-center justify-center text-center mx-auto">
                  {title && <h3 className="font-headings font-bold text-4xl justify-center">{title}</h3>}
                  {description && (
                    <div className="justify-center">
                      <RichTextRenderer content={description} />
                    </div>
                  )}
                </div>

                <div id="cards-container" className="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 grid-flow-row gap-6">
                  {cardIconItems?.map((cardIconItem, i) => cardIcon(cardIconItem, i))}
                </div>
                {button && <Button
                  id={button?.id}
                  type="button"
                  intent='black'
                  size='sm'
                  variant={'solid'}
                  className="bg-surface-950 border-surface-950 hover:border-surface-950 hover:bg-surface-0 hover:text-surface-950 text-surface-0"
                  icon={button?.iconName}
                  disabled={false}
                  onClick={() => router?.push(button?.CTA)}>{button?.label}</Button>
                }
              </div>
            </div>
          </section>
        </ContentLayout>
      </div>
    </ContentFullLayout>
  );
}

export default BannerCardsSection